export const GET_ACTIVE_WALLET_PLAN_REQUEST = "GET_ACTIVE_WALLET_PLAN_REQUEST";
export const GET_ACTIVE_WALLET_PLAN_SUCCESS = "GET_ACTIVE_WALLET_PLAN_SUCCESS";
export const GET_ACTIVE_WALLET_PLAN_FAILURE = "GET_ACTIVE_WALLET_PLAN_FAILURE";
export const GET_ACTIVE_WALLET_PLAN_RESET = "GET_ACTIVE_WALLET_PLAN_RESET";
export const getActiveWalletPlanRequest = (payload) => ({
    type: GET_ACTIVE_WALLET_PLAN_REQUEST,
    payload,
});
export const getActiveWalletPlanSuccess = (payload) => ({
    type: GET_ACTIVE_WALLET_PLAN_SUCCESS,
    payload,
});
export const getActiveWalletPlanFailure = (payload) => ({
    type: GET_ACTIVE_WALLET_PLAN_FAILURE,
    payload,
});
export const getActiveWalletPlanReset = () => ({
    type: GET_ACTIVE_WALLET_PLAN_RESET,
});
